<template>
  <div id="app">
      <router-view  v-if="isRouterAlive" ></router-view>
  </div>
  
</template>

<script>

export default {
  data() {
     return{
        isRouterAlive: true
     }
  },
   provide() {
      return {
        reload: this.reload
      }
    },
  methods: {
    reload() {
      console.log('刷新')
     this.isRouterAlive = false
     this.$nextTick(() => (this.isRouterAlive = true))
    }
   }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue